import { InfoOutlined } from '@mui/icons-material';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import styled from 'styled-components';
import COLORS from '../../colors';

interface TooltipBubbleProps {
  title: string;
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} arrow placement="right" classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: COLORS.TOOLTIP
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: COLORS.TOOLTIP,
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: '14px',
    maxWidth: '300px',
  },
}));

const StyledIconContainer = styled.div`
  margin-left: 8px;
  display: inline-block;
`;

const TooltipBubble = ({ title }: TooltipBubbleProps) => {
  return (
    <StyledTooltip title={title}>
      <StyledIconContainer>
        <InfoOutlined sx={{ width: 16, height: 16 }} />
      </StyledIconContainer>
    </StyledTooltip>
  );
};

export default TooltipBubble;
